var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXiaofangshuichi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fluent:swimming-pool-48-regular",
    clipPath: "url(#clip0_22_2132)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 561",
    d: "M2.75 7L3.13394 6.48808C4.49337 4.6755 7.16523 4.54388 8.69623 6.21407V6.21407C10.0883 7.73272 12.4656 7.78438 13.9224 6.32763L14.75 5.5",
    stroke: "#4A93FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 562",
    d: "M2.75 11L3.13394 10.4881C4.49337 8.6755 7.16523 8.54388 8.69623 10.2141V10.2141C10.0883 11.7327 12.4656 11.7844 13.9224 10.3276L14.75 9.5",
    stroke: "#4A93FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 563",
    d: "M1.75 2V14H15.75V2",
    stroke: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22_2132"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXiaofangshuichi);
export default __webpack_public_path__ + "static/media/xiaofangshuichi.cc41a8f95f7740fbcdd1c61f95186f5b.svg";
export { ForwardRef as ReactComponent };